import React, {useState} from 'react'
import {Card, Row, Col } from 'react-bootstrap'
import SketchfabSingleModel from '../common/SketchfabSingleModel'

const SketchfabChair = () => {
    const [modelIds, setModelIds] = useState("3516a7757ab14cef91f1e27422700d09");

  return (
    <>
    <Card className='no-border rounded-0 container sketchfab-chair-section'>
        <Row>
            <Col sm={{span:12, offset:0}} md={{span:5, offset:0}} id="first" className="no-padding-x">
                <div className="sketchfab-player-container">
                    <div className="sketchfab-player" style={{display: (modelIds === "3516a7757ab14cef91f1e27422700d09") ? "block" : "none"}}> 
                        <SketchfabSingleModel modelId="3516a7757ab14cef91f1e27422700d09" />
                    </div>
                    <div className="sketchfab-player" style={{display: (modelIds === "045ed432df124b1496e19dfd47779131") ? "block" : "none"}}> 
                        <SketchfabSingleModel modelId="045ed432df124b1496e19dfd47779131" />
                    </div>
                </div>
                <Card.Img className="no-padding-x chair-shadow" src={process.env.PUBLIC_URL + "assets/extra-common/chair-section-shadow.png"}  alt="" />
                <Row className="sketchfab-button-section">
                    <Col sm={12} className="thumbnail-location" >
                        <Row>
                            <Col  xs={{span:2, offset:4}} className={(modelIds === "3516a7757ab14cef91f1e27422700d09") ? "t1" : "t2"}> 
                                    <img className='img-fluid thumbnail-icons'  onClick={() => setModelIds("3516a7757ab14cef91f1e27422700d09") } src={process.env.PUBLIC_URL + "assets/thumbnails/gaming-chair.png"} alt="" />
                            </Col>
                            <Col  xs={{span:2, offset:0}} className={(modelIds === "045ed432df124b1496e19dfd47779131") ? "t1" : "t2"}> 
                                    <img className='img-fluid thumbnail-icons'  onClick={() => setModelIds("045ed432df124b1496e19dfd47779131") } src={process.env.PUBLIC_URL + "assets/thumbnails/reincliner-chair.png"}  alt=""/>
                            </Col>
                        </Row> 
                    </Col>
                </Row>
            </Col>
            <Col sm={{span:12, offset:0}} md={{span:7, offset:0}} id="second" className="">
                <div className="player-details">
                    <p className='player-header'>AR In - Home Viewing</p>
                    <p className='player-desc'>Once furniture and other 3D product models are created, they can be viewed by customers both on commerce websites and directly in their homes through AR. Though real - time rendering for AR does not yet match the quality of models made for Studio Photography Replacement, they provide buyers with a realistic preview of how the product will look and fit in their own home. This both increases likelihood of purchase and reduces returns, with happier customers.</p>
                    <p className='player-scan-desc'>Scan this code to open the model on your device, then, tap on the AR icon :</p>
                    <p>
                        <img src={process.env.PUBLIC_URL + "assets/thumbnails/" + (modelIds === "3516a7757ab14cef91f1e27422700d09" ? "qrchair.png" : "qrsofa.png")} className="player-scanner" alt=""/>
                    </p>
                    <p className='player-footnote'>
                    Augmented Reality is only available on mobile or tablet device <br /> <span style={{fontSize: "10px"}}>Supported devices : iPhone 6s+ & iPad5+ on iOS 12+ and Android 8.0+ with ARCore 1.9 support</span>
                    </p>
                </div>
            </Col>
        </Row>
    </Card>
    </>
  )
}

export default SketchfabChair
